import { computed } from 'vue';
import { mc, getPlatform } from '@mico/mico-base-common';

mc.install(getPlatform);

export function useNavigationHeight(fallback = 0) {
  return computed(() => mc.getPlatform().navigationHeight ?? fallback);
}
